import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";

import useAuth from "../hooks/useAuth";
import { RootContext } from "../context/RootContext";

// Each special user is restricted to their own application
const USER_HOME_ROUTES = {
  empire: "/empirehome",
  prestige: "/prestigehome",
  prestige_user: "/prestigehome",
  tablespace: "/tablespacehome",
  growel: "/growelhome",
  tanseeq: "/tanseeqhome",
};

const PrivateRoute = ({ children }) => {
  const isLoggedIn = useAuth();
  const location = useLocation();

  const { logoutRedirect } = useContext(RootContext);

  // -----------------------------------------
  // 1. Check login
  // -----------------------------------------
  if (!isLoggedIn) {
    return (
      <Navigate
        to={logoutRedirect || "/login"}
        replace
      />
    );
  }

  // -----------------------------------------
  // 2. Get logged-in user
  // -----------------------------------------
  let citriot = null;

  try {
    citriot = JSON.parse(localStorage.getItem("citriot"));
  } catch (error) {
    console.error("Invalid citriot data in localStorage:", error);
  }

  const user = citriot?.auth?.user?.toLowerCase().trim();

  // -----------------------------------------
  // 3. Check special-user route access
  // -----------------------------------------
  const userHomeRoute = USER_HOME_ROUTES[user];

  if (userHomeRoute) {
    const isAllowedRoute =
      location.pathname === userHomeRoute ||
      location.pathname.startsWith(`${userHomeRoute}/`);

    // User is trying to access another application's route
    if (!isAllowedRoute) {
      return (
        <Navigate
          to={userHomeRoute}
          replace
        />
      );
    }
  }

  // -----------------------------------------
  // 4. Allow the requested route
  // -----------------------------------------
  return <>{children}</>;
};

export default PrivateRoute;